// Styles for BrgClaimForm go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledBrgClaimForm = styled.div`
  .brg-container {
    margin: ${toRem(48)} 0;
    @media ${baseVariables.mediaQuery.md} {
      margin: ${toRem(80)} 0;
    }
  }
  .brg-form-container {
    display: flex;
    flex-direction: column;
    gap: ${toRem(16)};
    padding: ${toRem(32)} ${toRem(24)};
    margin-top: ${toRem(48)};
    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(32)} ${toRem(96)};
      gap: ${toRem(32)};
    }
  }
  .max-w-brg {
    max-width: ${toRem(734)};
  }
  .brg-form {
    display: flex;
    flex-direction: column;
    gap: ${toRem(48)};
  }
  h2 {
    font-size: 18px;
    font-weight: 700;
    line-height: 125%; /* 22.5px */
  }
  .m-form-group {
    margin-top: 1.5rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: ${toRem(24)};
    @media ${baseVariables.mediaQuery.md} {
      grid-template-columns: 1fr 1fr;
      gap: 2rem 3rem;
    }
  }
  .m-form-content-group {
    margin-top: 1.5rem;
    display: grid;
    grid-template-columns: 1fr;
    @media ${baseVariables.mediaQuery.md} {
      grid-template-columns: 1fr 1fr;
      gap: 0rem 3rem;
    }
  }
  .m-input-field {
    caret-color: auto;
  }

  .search-container {
    width: 100% !important;
  }

  .center-button {
    align-items: center;
    justify-content: center;
    display: inline-flex;
  }
  .submit-button {
    min-width: 100px;
  }

  input[type='text'].is-disabled,
  input[type='text']:disabled {
    color: #c4c4c4 !important;
  }
`;

export const GlobalStyles = createGlobalStyle`
  body {
    background-color: #f4f4f4 !important;
    .focus-error-indicator {
      input[type=radio] + label, input[type=checkbox] + label {
        &:before {
          border-color: var(--t-form-error-color);
        }
      }
    }
  }
`;
